<div>

    <div id="aqsn_title_header">
        <span id="acquisitionsTitle">Acquisitions and Commitments</span>
        <span id="count_aqsn_list_badge">{{countDiaplayedAqsnList}}</span>
    </div>

    <div id="acquisitionDealsTable" class="submittedFilesTable">
        <fm-table #acqntbl [columns]="cols5" [value]="acqnDetailsDashboardDisplay" sortMode="single" (onFilter)="onFilteredAcqnTable(acqntbl)"
            [loadingIcon]="true" [paginator]="true" [rows]="30" [rowsPerPageOptions]="[25,30,50,75,100,125,150,200]" [enableTableEntryTotal]="true" tableEntryTotalPosition="bottomLeft" paginatorPosition="bottomRight"
            [(selection)]="selectedReportArrayDisplay">

            <!-- Type to filter and Update Report -->
            <ng-template fmTemplate="caption">
                <div *ngIf="showAcqnTableEditCheckbox" style="float: right; margin-left: 10px"  >
                    <div *ngIf="selectedReportArrayDisplay.length != 0">
                        <button fmButton type="button" [secondary]="true" icon="fmi fmi-edit"
                            (click)="showUpdateReportComponent()"></button>
                    </div>
                    <div *ngIf="selectedReportArrayDisplay.length == 0">
                        <button fmButton type="button" [secondary]="true" icon="fmi fmi-edit"
                            (click)="showUpdateReportComponent()" disabled></button>
                    </div>
                </div>
                <div id="filterUpdateReport" style="color: #085280; display:inline">
                    <div style="text-align: left">
                        <input placeholder="Search" style="width:auto; float:left; margin-bottom: 10px;" fmTextInput type="text"
                            [(ngModel)]="acquisitionsFilterBinding"
                            (input)="acqntbl.filterGlobal($event.target.value, 'contains')" />
                    </div>
                    <button style="float: right; width: 200px; " fmButton type="button" [primary]="true" (click)="showAcqnFilterSidebar()" label="Filter"></button>

                    <div *ngIf="showDownloadButton == true && enableDownloadButton==false" style="float:right; margin-right:10px">
                        <button fmButton type="button" [secondary]="true" label="Export Report Data" 
                        (click)="downloadAcquisitionDealDetails(acqntbl.filteredValue)" disabled></button>
                    </div>
                    <div *ngIf="showDownloadButton == true && enableDownloadButton==true" style="float:right; margin-right:10px">
                        <button fmButton type="button" [secondary]="true" label="Export Report Data" 
                        (click)="downloadAcquisitionDealDetails(acqntbl.filteredValue)"></button>
                    </div>

                      <div *ngIf="showUploadPCAButton == true" style="float:right; margin-right:10px">
                        <button style="width: 200px;" fmButton type="button" [secondary]="true" label="Upload PCAs" 
                        (click)="showUploadFilesDialog(true)" ></button>
                    </div>
                  
                </div>
            </ng-template>

            <!-- Table header -->
            <ng-template fmTemplate="header" let-columns>
                <tr>
                    <th *ngFor="let col of columns" [fmSortableColumn]="col.field" [style.width]="col.width" style="color:#FFFFFF;">
                        {{col.header}}
                        <fm-sortIcon [field]="col.field"></fm-sortIcon>
                    </th>
                    <th *ngIf="showAcqnTableEditCheckbox" class="checkboxHeader"></th>
                </tr>
            </ng-template>

            <!-- Table body -->
            <ng-template fmTemplate="body" let-rowData let-columns="columns">
                <tr align="center">
                    <td *ngFor="let col of columns" (click)="showAcqnPropertyDetailsSidebar(rowData)">
                        <p *ngIf="col.field != 'aqsnDt' && col.field != 'reqdSubmtDt' && col.field != 'maxSubmtDt' && col.field != 'complianceRate'">
                            {{rowData[col.field]}}</p>
                        <p *ngIf="col.field == 'aqsnDt'">{{rowData[col.field] | date:'MM/dd/yyyy'}}</p>
                        <p *ngIf="col.field == 'reqdSubmtDt'">{{rowData[col.field] | date:'MM/dd/yyyy'}}</p>
                        <p *ngIf="col.field == 'maxSubmtDt'">{{rowData[col.field] | date:'MM/dd/yyyy'}}</p>
                        <p *ngIf="col.field == 'complianceRate'">
                            <button class="button_compliant" *ngIf="rowData[col.field] == 'Compliant'">Compliant</button>
                            <button class="button_non_compliant" *ngIf="rowData[col.field] == 'Non-Compliant'">Non-Compliant</button>
                            <button class="button_pending" *ngIf="rowData[col.field] == 'Pending'">Pending</button>
                        </p>
                    </td>
                    <td *ngIf="showAcqnTableEditCheckbox" class="checkbox">
                        <fm-tableCheckbox [value]="rowData"></fm-tableCheckbox>
                    </td>
                </tr>
            </ng-template>
        </fm-table>

        <div id="noDealsSubmitted" align="left" *ngIf="acqnDetailsDashboardDisplay.length === 0">
            <br>
            <i>{{tableNoAcqsnDealsMessage}}</i>
        </div>

        <br>
    </div>

    <!-- Update Report Component -->
    <app-acquisitions-update *ngIf="showAcqnUpdateComponent" [scrWidth]="screenWidth" [scrHeight]="screenHeight"
        [showAcqnUpdateComponent]="showAcqnUpdateComponent" [selectedReportArrayDisplayValue]="selectedReportArrayDisplay"
        (finishAndClosed)="onAcqnUpdateTableClose($event)">
    </app-acquisitions-update>
</div>
<app-file-upload *ngIf="showUploadFiles" (showUploadFiles)="getUploadFilesDialogStatus($event)"></app-file-upload>
